import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutTrailerToolPanel extends Layout {
    buttonLocateTrailer: Button;
    panelButtons: Panel;
    panelToolLeft: Panel;
    panelToolRight: Panel;
}
